export const getOpenOptionsFromBottom = (avoidMaxHeight = false) => ({
    style: {
        maxHeight: avoidMaxHeight ? 'none' : '350px',
    },
    anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'center',
    },
    transformOrigin: {
        vertical: 'top',
        horizontal: 'center',
    },
});
